export default {
  id: 119,
  title: 'Target #119 - Pacman',
  url: 'https://cssbattle.dev/play/119',
  colors: ['#000000', '#E0E246', '#C74E4E', '#FFFFFF'],
  solution:
    '<a a><a b><a c><a d><style>[a],[b]{top:120;width:60;height:60}[c],body{background:#000}[a],[d]{border-radius:9in}a{position:fixed}[a]{left:60;background:#e0e246}[b]{right:60;background:#c74e4e;border-radius:9in 9in 0 0}[c]{top:132.5;left:95;width:35;height:35;transform:rotate(45deg);box-shadow:155px -95px,170px -110px,184px -124px}[d]{top:145;left:165;width:10;height:10;background:#fff;color:#fff;box-shadow:30px 0,60px 0}</style>',
}
